import { PageEvent } from "./paginator";
import { FormRootDirective } from "../../form/form-root.directive";
import { FormContext } from "../../form/form-context";
import { ParentFieldFactory } from "../field-factory";
import { FormArray } from "@angular/forms";

export class ArrayRenderer {
  // TODO is arrayRoot needed
  constructor(private parentFieldFactory: ParentFieldFactory, private arrayRoot: FormRootDirective) {}

  public render(context: FormContext<any, FormArray>, pageEvent: PageEvent) {
    this.renderChildren(this.arrayRoot, this.getChildrenToRender(context.children as FormContext<any>[], pageEvent));
  }

  private renderChildren(arrayRoot: FormRootDirective, contexts: FormContext<any>[]): void {
    arrayRoot.clearView();

    contexts.forEach(context => {
      if (context.componentRef.hostView.destroyed) {
        // recreate the view if it is destroyed
        const newContext = this.parentFieldFactory.create<any>(context);

        this.parentFieldFactory.render(arrayRoot, newContext);
        return;
      }

      this.parentFieldFactory.render(arrayRoot, context);
    });
  }

  private getChildrenToRender(children: FormContext<any, any>[], pageEvent: PageEvent) {
    return children.slice(pageEvent.pageIndex * pageEvent.pageSize, (pageEvent.pageIndex + 1) * pageEvent.pageSize);
  }
}
